'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Language } from '@/src/types/flashcard';

interface LanguageState {
  nativeLanguage: Language;
  targetLanguage: Language;
  setNativeLanguage: (lang: Language) => void;
  setTargetLanguage: (lang: Language) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      nativeLanguage: 'ENGLISH',
      targetLanguage: 'JAPANESE',
      setNativeLanguage: (lang) => set({ nativeLanguage: lang }),
      setTargetLanguage: (lang) => set({ targetLanguage: lang }),
    }),
    { name: 'ukata-language-settings' }
  )
);
